import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'

import type { DrawerProps } from '../../../../ui/components'
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerTitle,
} from '../../../../ui/components'
import type { BestPaymentDrawer_PaymentOption$key } from './__generated__/BestPaymentDrawer_PaymentOption.graphql'
import { PaymentMethodInfoContent } from './PaymentMethodInfoContent'

const paymentOptionFragment = graphql`
  fragment BestPaymentDrawer_PaymentOption on PaymentOption {
    paymentMethod {
      name
    }
    ...PaymentMethodInfoContent_PaymentOption
  }
`

export type BestPaymentDrawerProps = DrawerProps & {
  paymentOptionRef: BestPaymentDrawer_PaymentOption$key
}

export const BestPaymentDrawer = ({
  paymentOptionRef,
  ...props
}: BestPaymentDrawerProps) => {
  const paymentOption = useSuspenseFragment(
    paymentOptionFragment,
    paymentOptionRef
  )

  return (
    <Drawer {...props}>
      <DrawerCloseButton />
      <DrawerTitle>{paymentOption.paymentMethod.name}</DrawerTitle>
      <DrawerBody>
        <PaymentMethodInfoContent paymentOptionRef={paymentOption} />
      </DrawerBody>
    </Drawer>
  )
}
